import { QSelect as e } from "quasar";
import { computed as t, createBlock as n, defineComponent as r, mergeModels as i, openBlock as a, unref as o, useModel as s } from "vue";
import { useI18n as c } from "vue-i18n";
import { getClient as l, getI18n as u, registerEntityEndpoint as d } from "@editor/ui-utils";
import { getDefaultSeoDescription as f, updateDefaultValues as p } from "@modules/news-article-utils";
import { defineStore as m } from "pinia";
//#region src/lib/article-type-options.ts
var h = t(() => [
	{
		value: "news",
		label: u().t("articlesEdit.articleTypeNews")
	},
	{
		value: "article",
		label: u().t("articlesEdit.articleTypeArticle")
	},
	{
		value: "test_report",
		label: u().t("articlesEdit.articleTypeTestReport")
	},
	{
		value: "guide",
		label: u().t("articlesEdit.articleTypeGuide")
	},
	{
		value: "download",
		label: u().t("articlesEdit.articleTypeDownload")
	}
]), ee = /* @__PURE__ */ r({
	__name: "article-type-filter.selector",
	props: /* @__PURE__ */ i({
		label: { default: void 0 },
		disable: {
			type: Boolean,
			default: !1
		}
	}, {
		modelValue: {},
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(t) {
		let { t: r } = c(), i = s(t, "modelValue", { set: (e) => {
			if (e !== null) return e;
		} });
		return (s, c) => (a(), n(o(e), {
			modelValue: i.value,
			"onUpdate:modelValue": c[0] ||= (e) => i.value = e,
			options: o(h),
			label: t.label ?? o(r)("articlesEdit.articleType"),
			disable: t.disable,
			"data-qa-article-type-filter-dropdown": "",
			"emit-value": "",
			"map-options": "",
			dense: "",
			flat: "",
			outlined: "",
			multiple: "",
			clearable: ""
		}, null, 8, [
			"modelValue",
			"options",
			"label",
			"disable"
		]));
	}
}), te = /* @__PURE__ */ r({
	__name: "article-type-selector",
	props: /* @__PURE__ */ i({
		label: { default: void 0 },
		rules: { default: void 0 },
		disable: {
			type: Boolean,
			default: !1
		},
		allowEmpty: {
			type: Boolean,
			default: !1
		}
	}, {
		modelValue: {},
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(t) {
		let { t: r } = c(), i = s(t, "modelValue", { set: (e) => {
			if (e !== null) return e;
		} });
		return (s, c) => (a(), n(o(e), {
			modelValue: i.value,
			"onUpdate:modelValue": c[0] ||= (e) => i.value = e,
			options: o(h),
			label: t.label ?? o(r)("articlesEdit.articleType"),
			"dropdown-icon": "expand_more",
			rules: t.rules,
			disable: t.disable,
			clearable: t.allowEmpty,
			"data-qa-article-type-dropdown": "",
			"emit-value": "",
			"map-options": "",
			dense: "",
			flat: "",
			outlined: ""
		}, null, 8, [
			"modelValue",
			"options",
			"label",
			"rules",
			"disable",
			"clearable"
		]));
	}
}), ne = Symbol("refreshArticlePreview"), g, re = new Uint8Array(16);
function _() {
	if (!g && (g = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !g)) throw Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
	return g(re);
}
//#endregion
//#region ../../../common/temp/node_modules/.pnpm/uuid@9.0.1/node_modules/uuid/dist/esm-browser/stringify.js
var v = [];
for (let e = 0; e < 256; ++e) v.push((e + 256).toString(16).slice(1));
function y(e, t = 0) {
	return v[e[t + 0]] + v[e[t + 1]] + v[e[t + 2]] + v[e[t + 3]] + "-" + v[e[t + 4]] + v[e[t + 5]] + "-" + v[e[t + 6]] + v[e[t + 7]] + "-" + v[e[t + 8]] + v[e[t + 9]] + "-" + v[e[t + 10]] + v[e[t + 11]] + v[e[t + 12]] + v[e[t + 13]] + v[e[t + 14]] + v[e[t + 15]];
}
var b = { randomUUID: typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto) };
//#endregion
//#region ../../../common/temp/node_modules/.pnpm/uuid@9.0.1/node_modules/uuid/dist/esm-browser/v4.js
function x(e, t, n) {
	if (b.randomUUID && !t && !e) return b.randomUUID();
	e ||= {};
	let r = e.random || (e.rng || _)();
	if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
		n ||= 0;
		for (let e = 0; e < 16; ++e) t[n + e] = r[e];
		return t;
	}
	return y(r);
}
//#endregion
//#region src/services/content.service.ts
var S = "Contents", C = d(S), { listEntities: w, getEntity: T, postEntity: E, putEntity: ie, deleteEntity: ae } = C, oe = async (e = null, t) => w({ params: {
	...e != null && { search: e },
	...t
} }), se = async (e, t = 1, n = 20) => w({ params: {
	...e.length ? { uuid: e } : {},
	page: t,
	size: n
} }), ce = async (e) => T(e), D = async (e) => {
	let { _id: t, createDate: n, changeDate: r, isDeleted: i, type: a, hasAffiliate: o, brand: s, deleteDate: c, vgwortPixel: l, legacy: u, ...d } = e;
	return E({
		...d,
		seoDescription: d.seoDescription || f(e)
	});
}, O = async (e, t) => {
	let { createDate: n, changeDate: r, isDeleted: i, type: a, hasAffiliate: o, brand: s, deleteDate: c, initialPublishedTitle: l, initialPublishDate: u, vgwortPixel: d, legacy: p, ...m } = t;
	return ie(e, {
		...m,
		seoDescription: m.seoDescription || f(t)
	});
}, k = (e) => ae(e), A = (e) => `cms/contents/${e}/workflow`, j = "cms/contents/workflow/used-in-references", M = "cms/contents/workflow/fixed-article-references", N = async (e) => (await l().get(A(e))).data, P = async (e) => {
	await l().put(j, e);
}, F = async (e) => {
	await l().put(M, e);
}, I = async (e) => {
	await l().post(`cms/contents/workflow/${e}/appeared-on-home`);
}, L = async (e) => {
	await l().delete(j, { data: e });
}, R = async ({ contentUuid: e, data: t }) => await l().post(A(e), t), z = async ({ contentUuid: e, data: t }) => await l().put(A(e), t), B = async ({ contentUuid: e, data: t }) => await l().patch(A(e), t), V = async (e) => (await l().get("/cms/locks", { params: { contentUuids: e } })).data, H = async ({ contentUuids: e = [], page: t = 1, size: n = 20 }) => (await l().get("/cms/contents/scheduled-changes/list", { params: {
	...e.length ? { contentUuids: e } : {},
	page: t,
	size: n
} })).data, le = async (e) => (await l().get(`/cms/contents/${e}/scheduled-changes`)).data, U = async ({ contentUuid: e, data: t }) => (await l().post(`/cms/contents/${e}/scheduled-changes`, t)).data, W = async ({ contentUuid: e, data: t }) => (await l().put(`/cms/contents/${e}/scheduled-changes`, t)).data, ue = async (e) => (await l().delete(`/cms/contents/${e}/scheduled-changes`)).data, de = async (e, t) => (await l().put(`/cms/contents/${e}/legacy-migration`, t)).data, G = () => J({
	type: "TEXT",
	content: "<p></p>"
}), K = () => ({
	_id: "",
	type: "CONTENT",
	createDate: /* @__PURE__ */ new Date(),
	changeDate: /* @__PURE__ */ new Date(),
	bfJobUuid: "",
	channelUuid: "",
	secondaryChannelUuids: [],
	kicker: "",
	title: "",
	seoTitle: "",
	contextLabel: "",
	leadText: "",
	seoDescription: "",
	description: "",
	displayDate: void 0,
	publishDate: void 0,
	paths: [],
	slug: "",
	linkedTagsUuids: [],
	isTeaserDataShown: !1,
	contentsRef: [G()],
	mainMediaRef: {
		mediaType: "image",
		imageUuid: ""
	},
	ads: {
		adTags: [],
		isAdsEnabled: !0,
		hasAdvertisementMark: !1,
		isOutstreamEnabled: !0
	},
	hasAffiliate: !1,
	articleAuthorshipRef: {
		type: "news_article",
		authorUuids: []
	},
	brand: "",
	listingImageUuid: "",
	unpublishDate: void 0,
	isNoIndex: !1,
	isDeleted: !1,
	isHiddenFromNewsticker: !1,
	isHiddenFromTeaserList: !1,
	state: "draft",
	legacy: {
		source: "vibe",
		isEditableInCTF: !0,
		isRenderedByCTF: !0,
		hasBeenModifiedInCTF: !0
	},
	tracking: { pageContentSourceDetail: "" },
	feeds: {
		msnAt: "exclude",
		msnCh: "exclude",
		msnDe: "auto",
		yahoo: "auto"
	},
	vgwortPixel: {
		pixelUrl: "",
		isLegacyPixel: !1
	},
	articleType: "news"
}), fe = async (e) => (await l().get(`/cms/contents/${e}/check-path-conflict`)).data;
//#endregion
//#region src/lib/contentBlocks.ts
function q(e) {
	return !!e && "_key" in e;
}
function J(e) {
	if (!e) {
		let e = G();
		return console.error(`Attempted to add a key to non-existing content block -> fallback to default content block ${e.type}`), e;
	}
	return q(e) ? e : {
		_key: x(),
		...e
	};
}
function Y(e) {
	if (!q(e)) return e;
	let { _key: t, ...n } = e;
	return n;
}
function X(e) {
	if (e.contentsRef?.length) for (let t = 0; t < e.contentsRef.length; t++) {
		let n = e.contentsRef[t];
		if (!q(n)) try {
			e.contentsRef[t] = J(n);
		} catch (e) {
			console.error(`Error adding key to content block on index ${t}:`, e);
		}
	}
}
function pe(e) {
	if (e.contentsRef?.length) for (let t = 0; t < e.contentsRef.length; t++) {
		let n = e.contentsRef[t];
		if (q(n)) try {
			e.contentsRef[t] = Y(n);
		} catch (e) {
			console.error(`Error removing key from content block on index ${t}:`, e);
		}
	}
}
function me(e) {
	return e?.length ? e.map(J) : [];
}
function he(e) {
	return e?.length ? e.map(Y) : [];
}
//#endregion
//#region src/lib/events.ts
var Z = "onContentCreated", ge = class extends CustomEvent {
	constructor(e) {
		super(Z, { detail: e });
	}
}, Q = m("content", {
	state: () => ({
		loading: !1,
		content: K(),
		invalidTabs: [],
		activePanel: "article",
		prefillSource: void 0,
		meta: {
			updateShownDate: !1,
			updatePublishDate: !1,
			isEditingScheduledChange: !1,
			isBrandFieldDisabled: !1,
			titleLength: 0,
			teaserTitleLength: 0
		}
	}),
	actions: {
		async createContent() {
			this.loading = !0;
			try {
				let { _id: e } = await D(this.content);
				return this.content._id = e, this.loading = !1, e;
			} catch {
				this.loading = !1;
			}
			return "";
		},
		async updateContent() {
			if (this.content._id) {
				this.loading = !0;
				try {
					await O(this.content._id, this.content);
				} catch {}
				this.loading = !1;
			}
		},
		async deleteContent() {
			if (this.content._id) {
				this.loading = !0;
				try {
					await k(this.content._id);
				} catch {}
				this.loading = !1;
			}
		},
		updateBlocksArray(e) {
			this.content.contentsRef = e;
		},
		updateTitleLength(e) {
			this.meta.titleLength = e;
		},
		updateTeaserTitleLength(e) {
			this.meta.teaserTitleLength = e;
		},
		updateInvalidTabs(e) {
			this.invalidTabs.push(e);
		},
		resetInvalidTabs() {
			this.invalidTabs = [];
		},
		updateActivePanel(e) {
			this.activePanel = e;
		},
		updateBrand(e) {
			e && e !== this.content.brand && (this.content.secondaryChannelUuids = []), this.content.brand = e;
		}
	}
}), _e = (e, t, n) => {
	let r = Q();
	r.prefillSource = e, r.content = {
		...K(),
		...t
	}, r.meta = {
		...r.meta,
		...n
	}, p(r.content);
}, $ = (e, t) => `${e}:${t}`, ve = (e, t) => {
	let n = {
		...e,
		...t.fields
	};
	return X(n), n;
}, ye = m("pendingContentUpdate", {
	state: () => ({ pendingUpdates: {} }),
	actions: {
		setPendingUpdate(e) {
			let t = $(e.contentUuid, e.brand);
			this.pendingUpdates = {
				...this.pendingUpdates,
				[t]: e
			};
		},
		clearPendingUpdate(e, t) {
			if (e && t) {
				let n = $(e, t);
				if (!this.pendingUpdates[n]) return;
				let r = { ...this.pendingUpdates };
				delete r[n], this.pendingUpdates = r;
				return;
			}
			this.pendingUpdates = {};
		},
		takePendingUpdate(e, t) {
			let n = $(e, t), r = this.pendingUpdates[n];
			if (!r) return;
			let i = { ...this.pendingUpdates };
			return delete i[n], this.pendingUpdates = i, r;
		}
	}
});
//#endregion
export { ee as ArticleTypeFilter, te as ArticleTypeSelector, S as ContentModelName, C as ContentService, ge as OnContentCreatedEvent, F as addContentWorkflowFixedArticleReferences, P as addContentWorkflowUsedInReferences, J as addKeyToBlock, me as addKeysToContentBlocks, ve as applyPendingContentUpdate, $ as buildPendingContentUpdateKey, I as checkAppearedOnHome, fe as checkPathConflict, D as createContent, R as createContentWorkflow, U as createScheduledChanges, k as deleteContent, ue as deleteScheduledChanges, ce as getContent, V as getContentLocks, N as getContentWorkflow, oe as getContents, se as getContentsFromIds, K as getDefaultStateContent, G as getDefaultStateContentBlock, le as getScheduledChanges, q as hasContentBlockKey, H as listScheduledChanges, X as mutateAddKeysToContentBlocks, pe as mutateRemoveKeysFromContentBlocks, Z as onContentCreatedEventType, B as partialUpdateContentWorkflow, _e as prefillEditorContent, ne as refreshArticlePreviewKey, L as removeContentWorkflowUsedInReferences, Y as removeKeyFromBlock, he as removeKeysFromContentBlocks, O as updateContent, z as updateContentWorkflow, de as updateLegacyMigration, W as updateScheduledChanges, Q as useEditorContent, ye as usePendingContentUpdateStore };

//# sourceMappingURL=index.es.js.map